module.exports = "/img/service-3.497a5d17.png";